import { decodeShortId } from './decodeId';

const pattern =
  /^[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{21,22}$/;

export function isShortId(id: any): boolean {
  if (typeof id !== 'string') return false;
  if (!pattern.test(id)) return false;

  try {
    const decoded = decodeShortId(id);
    return decoded.length === 16;
  } catch {
    return false;
  }
}
